import * as React from "react";
import { useContext, useEffect } from "react";
import RenderCompletionCallback from "views/components/widgets/RenderCompletionCallback";
const RenderTypeNotSupported = ({ renderType }) => {
  const onRenderComplete = useContext(RenderCompletionCallback);
  useEffect(() => {
    onRenderComplete();
  }, [onRenderComplete]);
  return /* @__PURE__ */ React.createElement("div", null, 'Render type "', renderType, '" is not supported.');
};
export default RenderTypeNotSupported;
